import { render, staticRenderFns } from "./superadminDashboard.vue?vue&type=template&id=5b5b9ae2&scoped=true&"
import script from "./superadminDashboard.vue?vue&type=script&lang=js&"
export * from "./superadminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./superadminDashboard.vue?vue&type=style&index=0&id=5b5b9ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b9ae2",
  null
  
)

export default component.exports